import { render, staticRenderFns } from "./TheLevelScreen.vue?vue&type=template&id=c3fcac60&"
import script from "./TheLevelScreen.vue?vue&type=script&lang=js&"
export * from "./TheLevelScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports